export const createAnchor = (className = ``, text = ``, href = ``) => {
  const a = document.createElement(`a`);
  a.className = className;
  a.innerHTML = text;
  a.href = href;

  return a;
};
